import { OpenInNew } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { DARK_THEME } from '../../../../Redux/Types/themeTypes';
import docsLogo from '../../../../assets/images/docsLogo.svg';
import { currentDomain } from '../../../../utils/domainBasedInfo/currentDomain';

function NavigationBar({ currentTheme, handleNavigation, activeNav }) {
	return (
		<Stack
			flexDirection="row"
			alignItems="center"
			justifyContent="center"
			gap="30px"
			className="appBar-navbar"
			cy-data="navigation-bar"
			sx={(theme) => ({
				[theme.breakpoints.down('md')]: {
					display: 'none',
				},
			})}
		>
			{currentDomain.header.navigation.map((navItem) => (
				<Box
					key={navItem.name}
					className={`appBar-navItem ${
						activeNav === navItem.name ? 'active' : 'navItem-link'
					} ${
						currentTheme === DARK_THEME &&
						navItem.name !== 'Old version' &&
						'invert'
					}`}
					onClick={() => handleNavigation(navItem)}
					cy-data={navItem.name}
				>
					<img
						src={navItem.icon}
						alt={navItem.name}
						className="nav-img"
						width={25}
						height={25}
					/>
					<Typography className="appBar-nav-item-text">
						{navItem.name}
					</Typography>
				</Box>
			))}
			<Box
				// className="appBar-navItem navItem-link invert link-box"
				className={`appBar-navItem navItem-link ${
					currentTheme === DARK_THEME && 'invert'
				}`}
				onClick={() =>
					window.open(
						'https://docs.qbraid.com/lab/user-guide/overview',
						'_blank'
					)
				}
				cy-data="qBraid-docs"
				title="open in new window"
			>
				<img
					src={docsLogo}
					alt="nav item"
					className="nav-img"
					width={25}
					height={25}
				/>
				<Stack
					flexDirection="row"
					gap={0.3}
					alignItems="center"
					className="expand-link"
				>
					<Typography className="appBar-nav-item-text">Docs</Typography>
					<OpenInNew fontSize="8px" size="small" className="docs_icon-link" />
				</Stack>
			</Box>
			{currentDomain.header.extraNavigation.map((navItem) => (
				<Box
					className="appBar-navItem navItem-link"
					onClick={() => window.open(navItem.link, '_blank')}
					cy-data="qusteam-canvas"
					title="open in new window"
				>
					<img
						src={currentTheme === DARK_THEME ? navItem.icon_dark : navItem.icon}
						alt={navItem.name}
						className={
							currentTheme === DARK_THEME ? 'nav-canvas-img' : 'nav-img'
						}
					/>
					<Stack
						flexDirection="row"
						gap={0.3}
						alignItems="center"
						className="expand-link"
					>
						<Typography className="appBar-nav-item-text">
							Launch {navItem.name}
						</Typography>
						<OpenInNew fontSize="8px" size="small" className="docs_icon-link" />
					</Stack>
				</Box>
			))}
		</Stack>
	);
}

export default NavigationBar;
